import { cn } from "@lib/utils/ui";
import type { ActionState } from "../actions";
type FormAlertProps = {
  state: ActionState;
  isPending: boolean;
  className?: string;
};
export function FormAlert({
  state,
  isPending,
  className
}: FormAlertProps) {
  if (isPending || state.result === "idle" || !state.message) {
    return null;
  }
  return <div className={cn("p-3 rounded-md text-center", state.result === "success" ? "bg-green-100 text-green-700" : "bg-red-100 text-red-700", className)} data-sentry-component="FormAlert" data-sentry-source-file="FormAlert.tsx">
      {state.message}
    </div>;
}